// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"GiftingModal_modalContainer__fmdpR","modalContent":"GiftingModal_modalContent__3DIIF"};